import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13.333 13.333"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.667 3.225a.583.583 0 0 0-.584.583v3.625a.59.59 0 0 0 .584.583.59.59 0 0 0 .583-.583V3.808a.583.583 0 0 0-.583-.583M6.667 8.942a.59.59 0 0 1 .583.583.583.583 0 1 1-1.167 0 .59.59 0 0 1 .584-.583"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.667 1.182a5.484 5.484 0 1 0 0 10.97 5.484 5.484 0 0 0 0-10.97M0 6.667a6.667 6.667 0 1 1 13.333 0A6.667 6.667 0 0 1 0 6.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }